// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"435":"b40cd2de","2589":"d58c8f4e","2682":"930df20d","3405":"00ada90c"}[chunkId] + ".css";
};